import { Component } from '@angular/core';

@Component({
  templateUrl: './test-component.component.html',
})
/**
 * A comopnent to route to in tests
 */
export class TestComponent {}
